import { Component, OnInit } from '@angular/core';
import { NgxExtendedPdfViewerService } from 'ngx-extended-pdf-viewer';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-fileviewer',
  templateUrl: './fileviewer.component.html',
  styleUrls: ['./fileviewer.component.scss'],
})
export class FileviewerComponent implements OnInit {
  public pdfConverted: string = null;
  public currentPage = 1;
  public autoPrint = 'false';
  constructor(
    public dataService: DataService,
    private pdfService: NgxExtendedPdfViewerService
  ) {}

  ngOnInit(): void {
    if (sessionStorage.getItem('pdf')) {
      this.pdfConverted = sessionStorage.getItem('pdf');
    }
    if (sessionStorage.getItem('iCourrierPdfAutoPrint')) {
      this.autoPrint = sessionStorage.getItem('iCourrierPdfAutoPrint');
    }
  }

  pageRendered() {
    if (this.autoPrint) {
      this.pdfService.print();
    }
  }
}
